// extracted by mini-css-extract-plugin
export default {"Spring":"Spring-module__Spring--cknL1","Spring--small":"Spring-module__Spring--small--Ej5G2","Spring--fullBleedMobile":"Spring-module__Spring--fullBleedMobile--RjeAc"};